import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { DataService } from "../../bpg-common/services/data.services";
import { BpgEventsService } from "../../bpg-events/bpg-events.service";
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';
import { BpgExpensesService } from '../bpg-expenses.service';

@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.css']
})
export class ExpenseComponent implements OnInit {

  siteList: any;
  isErgAdmin = false;
  isNaacAdmin = false;
  userAndRoleIdDTO: any;
  statusList: any;
  chapterList: any;
  siteData: any;
  selectedFy: any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  adminId: any = localStorage.getItem('adminId');
  selectAllConstant = "Select All";
  landingData: any;
  chapterIds: string;
  tableShow: boolean;
  onFirstRender = false;
  allSiteIds: any;
  selectedErgsData: any;
  siteId: any = 0;
  ergList: any;
  allErgIds: any;
  tableresp: boolean;
  selectedErgId: any;
  timeOutError: boolean;
  buttonUsed: any;
  previousButton: any;
  expenseData: any;
  expenseKeyList: any;
  noDataFound: boolean;
  bpgId: any = 0;
  status: any;
  currentPage = 0;
  expenseList: any[] = [];
  alertSuccess: boolean;
  searchKey: any;
  ergValue: any;
  fyList: any;
  numberOfElements: number;
  selectedSiteId: any ;
  expenseDetails: any[] = [];
  selectedStatus: any;
  method: string;
  msg1: string;
  param: string;
  fySelected: string;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  currentFiscalYear: number;
  constructor(private readonly router: Router,
    private readonly bpgCommonService: BpgCommonService,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly data: DataService,
    private readonly bpgExpensesService: BpgExpensesService,
    private readonly bpgEventsService: BpgEventsService,
    private readonly environment: EnvironmentConfiguration) { }

  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
      if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }

    if (localStorage.getItem('isbpgAdmin') === 'true') {
      this.isErgAdmin = true
    }
    if (localStorage.getItem('isNaacAdmin') === 'true') {
      this.isNaacAdmin = true
    }
    this.userAndRoleIdDTO = {
      userId: this.loginData['userId'],
      roleId: localStorage.getItem('adminId')
    }
    localStorage.removeItem('searchedEventsCaledarItems');
    if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && this.adminId !== "4" && !this.isNaacAdmin && !this.isErgAdmin) {
      this.router.navigate(['/site-home']);
    }
    this.spinner.show();
    this.statusList = [{ status: this.selectAllConstant }, { status: "NEW" }, { status: "SCHEDULED" }, { status: "SUBMITTED" }, { status: "APPROVED" }, { status: "REJECTED" }]
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    // If the month is before April, the fiscal year is the previous year
    if (month < 4) {
        this.currentFiscalYear = year;
    } else {
        this.currentFiscalYear = year+1;
    }
    this.fyList = [{ fySelected: this.selectAllConstant }, { fySelected: `FY${(this.currentFiscalYear+1) % 100}` },
    {fySelected:`FY${(this.currentFiscalYear) % 100}`},{fySelected:`FY${(this.currentFiscalYear-1) % 100}`}, { fySelected: "Past FYs" }];
      this.landingData = {
      "filter": { "chapterId": "" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": ConstantValues.pageLimit,
      "sortDirection": "DESC",
      "sortProperty": "created_date_time",
      "uid": ""
    }
    this.adminId = localStorage.getItem('adminId');
    this.tableShow = false;
    this.data.saveData('default Message');
    this.onFirstRender = true;
    this.spinner.show();
    this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
      this.chapterList = data;
      this.chapterList.map((i) => { i.siteName = `${i.siteName}-${i.bpgName}`; return i; })
      if (this.chapterList.length > 1) {
        this.chapterList.unshift({ chapterId: 0, siteName: this.selectAllConstant, bpgName: '' });
      }
      for (let i = 0; i < this.chapterList.length; i++) {
        if (i === 0) {
          this.chapterIds = this.chapterList[i].chapterId;
        }
        else {
          this.chapterIds = `${this.chapterIds},${this.chapterList[i].chapterId}`;
        }
      }
      this.siteData = {
        "filter": {
          chapterId: this.chapterIds
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "",
        "searchTerm": "",
        "size": 0,
        "sortDirection": "ASC",
        "sortProperty": "",
        "uid": ""
      }
      this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
        this.siteList = data;
        //filter default site from sitelist
        this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT'); this.siteList.unshift({ siteId: 0, siteName: this.selectAllConstant, bpgName: '' });
        for (let i = 0; i < this.siteList.length; i++) {
          if (i === 0) {
            this.allSiteIds = this.siteList[i].siteId;
          } else {
            this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
          }
        }
        if (this.adminId === "1" || this.adminId === "4") {
          this.siteChange(0);
        }

        this.selectedErgsData =
        {
          "filter": {
            "siteId": this.siteId,
            "userId": this.userAndRoleIdDTO.userId,
            "adminId": this.userAndRoleIdDTO.roleId
          },
          "moduleId": 0,
          "page": 0,
          "presentRole": "string",
          "searchTerm": "string",
          "size": 0,
          "sortDirection": "ASC",
          "sortProperty": "string",
          "uid": "string"
        }
        this.bpgCommonService.getMyBPGsList(this.selectedErgsData).subscribe(data => {
          this.ergList = data;
          // if (this.bpgList.length > 1) {
            this.ergList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });
          // }
          for (let i = 0; i < this.ergList.length; i++) {
            if (i === 0) {
              this.allErgIds = this.ergList[i].bpgId;
            } else {
              this.allErgIds = `${this.allErgIds}${this.ergList[i].bpgId},`;
            }
          }

          this.landingData.filter.chapterId = this.chapterIds;

          if (this.adminId !== "1" && this.adminId !== "4") {
            this.landingData.filter.siteId = this.allSiteIds;
            this.landingData.filter.bpgId = this.allErgIds;
          }

          this.previousButton = sessionStorage.getItem(this.buttonUsed);
          if (this.previousButton === 'BACK' || this.previousButton === 'CANCEL') {
            this.expenseData = JSON.parse(localStorage.getItem('searchedExpenseList'));
            this.tableShow = true;
            this.currentPage = this.expenseData.page + 1;
            this.landingData = this.expenseData;
            this.getExpenseList();
            localStorage.removeItem('searchedExpenseList');

            this.searchKey = this.expenseData.searchTerm;
            if (this.expenseData.filter.siteId !== undefined && this.expenseData.filter.siteId.length > 1) {
              this.siteId = 0;
            }
            else {
              this.siteId = this.expenseData.filter.siteId;
            }
            if (this.expenseData.filter.bpgId != undefined && this.expenseData.filter.bpgId.length > 1) {
              this.bpgId = 0;
            }
            else {
              this.bpgId = this.expenseData.filter.bpgId;
            }
            if (this.expenseData.filter.status === null) {
              this.status = this.selectAllConstant;
            }
            else {
              this.status = this.expenseData.filter.status;
            }
            if (this.expenseData.filter.fiscalYear === null || this.expenseData.filter.fiscalYear === 'All') {
              this.fySelected = this.selectAllConstant;
            }else {
              this.fySelected = this.expenseData.filter.fiscalYear;
              if(this.fySelected!=='All' && this.fySelected!=="Past FYs"){
                  this.fySelected = `FY${this.expenseData.filter.fiscalYear % 100}`;
              }
            }
            this.selectedFy = this.fySelected;
          }
          else {
            this.spinner.show();
            // on page load display only current fiscal years data
            this.landingData.filter.fiscalYear = this.currentFiscalYear;
            this.fySelected = `FY${this.currentFiscalYear % 100}`;
            this.selectedFy = this.fySelected;
            this.getExpenseList();
          }
        });
      });
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });


    if (window.innerWidth < 767) {
      this.tableresp = true;
    } else {
      this.tableresp = false;
    }
  }

  /** For getting all expense data
  * @class ExpenseClaimListComponent
  * @method getExpenseList
  */
  public getExpenseList() {
    this.timeOutError = false;
    this.spinner.show();
    // this.landingData.filter.status = null;
    this.bpgExpensesService.getExpenses(this.landingData).subscribe(data => {
      this.tableShow = true;
      this.spinner.hide();
      this.expenseList = data.content;
      this.numberOfElements = data.totalElements;
      sessionStorage.removeItem(this.buttonUsed);
      localStorage.setItem('searchedExpenseList', JSON.stringify(this.landingData));
      if (this.expenseList.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.spinner.hide();

        this.noDataFound = false;
      }
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** For site change from site list 
* @class ExpenseClaimListComponent
* @method siteChange
* @returns Promise
*/
  public siteChange(event) {
    this.ergList = [];
    this.selectedErgId = null;
    this.ergValue = null;

    if (event !== undefined) {
      this.selectedSiteId = event.siteId;
    } else {
      this.selectedSiteId = 0;
      this.selectedSiteId = null;
    }

    this.selectedErgsData =
    {
      "filter": {
        "siteId": this.selectedSiteId,
        "userId": this.userAndRoleIdDTO.userId,
        "adminId": this.userAndRoleIdDTO.roleId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getMyBPGsList(this.selectedErgsData).subscribe(data => {
      this.ergList = data;
      if (this.ergList.length > 1) {
        this.ergList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });
      }
      for (let i = 0; i < this.ergList.length; i++) {
        if (i === 0) {
          this.allErgIds = this.ergList[i].bpgId;
        } else {
          this.allErgIds = `${this.allErgIds}${this.ergList[i].bpgId},`;
        }
      }
    });
  }

  searchExpense() {
    this.currentShowingElements = ConstantValues.pageLimit;
    this.spinner.show();
    this.selectedSiteId = this.siteId;
    this.selectedErgId = this.bpgId;
    this.selectedStatus = this.status;

    this.selectedSiteId = (this.selectedSiteId) ? this.selectedSiteId : null;
    this.selectedErgId = (this.selectedErgId) ? this.selectedErgId : null;
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    if (this.selectedErgId === 0 || this.selectedErgId === null) {
      this.selectedErgId = this.allErgIds;
    }
    if (this.selectedSiteId === 0 || this.selectedSiteId === null) {
      this.selectedSiteId = this.allSiteIds;
    }
    if (this.selectedStatus === this.selectAllConstant) {
      this.selectedStatus = null;
    }
    if (this.selectedFy === this.selectAllConstant) {
      this.selectedFy = "All"
    }
    // pass the fiscal year correctly
    if(this.selectedFy !== 'All' && this.selectedFy !== 'Past FYs' && this.selectedFy !== this.selectAllConstant){
      this.selectedFy = this.getFiscalYear(this.selectedFy);
    }
    this.landingData =
    {
      "filter": {
        "siteId": this.selectedSiteId,
        "bpgId": this.selectedErgId,
        "status": this.selectedStatus,
        "fiscalYear": this.selectedFy,
        "search": true
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": this.searchKey,
      "size": ConstantValues.pageLimit,
      "sortDirection": "ASC",
      "sortProperty": "submission_date",
      "uid": "1"
    }


    this.bpgExpensesService.getExpenses(this.landingData).subscribe(data => {
      this.tableShow = true;
      this.expenseList = data.content;
      localStorage.setItem('searchedExpenseList', JSON.stringify(this.landingData));
      this.numberOfElements = data.totalElements;
      this.currentPage = 1;
      if (this.expenseList.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
      }
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  public viewMoreExpenseDetails(expenseId, type) {
    if (type === "VIEW") {
      sessionStorage.setItem(this.expenseKeyList, "VE");
    }
    if (type === "APPROVED") {
      sessionStorage.setItem(this.expenseKeyList, "AE");
    }
    if (type === "REJECTED") {
      sessionStorage.setItem(this.expenseKeyList, "RE");
    }

    for (const expense of this.expenseList) {
      if (expense.expenseId === expenseId) {
        this.expenseDetails = expense;
        sessionStorage.setItem("expenseDetails", JSON.stringify(this.expenseDetails));
        this.data.setApproved(type);
        this.router.navigate(['claim-expense-approval']);
      }
    }
  }

  editExpense(data) {
    sessionStorage.setItem('editExpenseData', JSON.stringify(data));
    sessionStorage.removeItem("expenseNameAndChapterId");
  }

  // getPastBudgets(){
  //   this.showScheduledBudgets = false;
  //   this.showPastBudgets = true;
  //   this.searchExpense();
  // }

  /** To delete the expense data, this function calls when user clicks delete icon
 * @class ExpenseClaimListComponent
 * @method deleteClick
 */
  deleteClick(expenseId) {
    this.method = "changeExpenseStatus";
    this.param = "DELETED";
    this.msg1 = " Are you sure you want to delete this expense ? ";
    this.landingData.expenseId = expenseId;
  }

  /** For bpg change from bpg list 
* @class ExpenseClaimListComponent
* @method bpgChange
* @returns Promise
*/

  ergChange(event) {
    if (event !== undefined) {
      this.selectedErgId = event.bpgId;
    } else {
      this.selectedErgId = null;
    }
  }

  /** For bpg change from bpg list 
* @class ExpenseClaimListComponent
* @method changeStatus
* @returns Promise
*/

  changeStatus(event) {
    if (event !== undefined) {
      this.selectedStatus = event.status;
    } else {
      this.selectedStatus = null;
    }
  }

  changeFYSelected(event) {
    if (event !== undefined) {
      this.selectedFy = event.fySelected;
    } else {
      this.selectedFy = null;
    }
  }

  /** To change the expense status 
* @class ExpenseClaimListComponent
* @method changeExpenseStatus
*/
  changeExpenseStatus(type) {
    if (type === 'DELETED') {
      /*for soft delete on database*/
      this.landingData.approvalComment = null;
      this.landingData.approvedBy = this.adminId;
      this.landingData.expenseStatus = 'DELETED';
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.alertSuccess = true;
      setTimeout(function () {
        window.location.reload();
        this.alertSuccess = false;
      }.bind(this), 4000);
    }
    this.bpgEventsService.updateExpenseStatus(this.landingData).subscribe(_data => {
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  pageChanged(event) {

    this.landingData.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) > this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getExpenseList();
  }

  /** For clearing parameters
* @class ExpenseClaimListComponent
* @method clearExpenseClaimData
*/
  public clearExpenseClaimData() {
    sessionStorage.removeItem('editExpenseData');
    sessionStorage.removeItem("expenseNameAndChapterId");
  }

  getFiscalYear(fyString: string): number {
    const yearPart = parseInt(fyString.toString().slice(2), 10);
    const currentYear = new Date().getFullYear();
    const currentCentury = Math.floor(currentYear / 100) * 100;
    return currentCentury + yearPart;
  }

  navigateToActuals(){
    this.router.navigate(['/actuals']);
  }

}
